import Vue from 'vue';
import _ from 'lodash';

export default {
  SET_ONLINE_STATE(state: any, payload: boolean) {
    state.isOnline = payload;
  },
  SCANNER_CONNECTED(state: any, payload: boolean) {
    state.scanner.connected = payload;
  },
  SCANNER_VALUE(state: any, payload: string) {
    let i = _.get(state, 'scanner.value.i', 0);
    i++;
    Vue.set(state.scanner, 'value', {
      value: payload,
      i
    });
  }
};
